// eslint-disable-next-line
import { types, NAME } from './reducer'
import { MATCHING } from "../../constants/matching";
import { MISSMATCHING } from "../../constants/missmatching";
import { shuffle } from ".././/../helpers/arrayFunctions"

const lang = document.documentElement.lang.slice(0, 2); 

export const actions = {
  getSubscription: () => ({
    //
  }),
  startPreExersize: () => (dispatch, getState) => {
    dispatch({
      type: "PREEXERSIZE"
    })
  },
  incrementCountDown: () => ({
    type: "INCREMENT_COUNTDOWN"
  }),
  increment: () => ({
    type: "INCREMENT"
  }),
  setIncrementCountDown: (newCountDown) => ({
    type: "SET_INCREMENT_COUNT_DOWN",
    newCountDown
  }),
  showTxtSelector: () => ({
    type: "SHOW_TXT_SELECTOR"
  }),
  hideTxtSelector: () => ({
    type: "HIDE_TXT_SELECTOR"
  }),
  startGame: (newCountDown) => (dispatch, getState) => {
    let startTime = new Date().getTime()
    dispatch({
      type: "START_GAME",
      newCountDown,
      startTime
    })
  },
  showQuestions: () => ({
    type: 'SHOW_QUESTIONS',
    endTime: new Date().getTime()
  }),
  gameOverAction: () => (dispatch, getState) => {
    dispatch({
      type: "GAME_OVER"
    })
  },
  showGameOverScreanAction: () => ({
    type: "SHOW_GAME_OVER_SCREAN"
  }),
  setText: (item,textLevel) => (dispatch, getState) => {
    dispatch({
      type: "SET_TEXT",
      text: item.text,
      textName: item.name,
      questions: (() => {
        let questions = item.questions
        questions.map( item => {
          item.variants = shuffle(item.variants)
        })
        return questions
      })(),
      wordsInText: item.text.split(" ").length,
      textLevel: textLevel
    })
  },
  readingFinishedAction: () => ({
    type: "FINISH_READING",
  }),
  newRound: () => (dispatch, getState) => {
    dispatch({
      type: "NEW_ROUND"
    })
  },
  answerClick: (isRight, answerIndex) => (dispatch, getState) => {
    let state = getState().WPM_TEST
    let data = {} 
    data.points = state.points
    data.answerIndex = answerIndex
      if (isRight) {
        data.showAnswerRight = true
        data.points++
      } else {
        data.showAnswerWrong = true
      }
    setTimeout(() => {
      dispatch(actions.switchQuestion())
    },1410)
    dispatch({
      type: "ANSWER_CLICK",
      data: data
    })
  },
  switchQuestion: () => (dispatch, getState) => {
    let state = getState().WPM_TEST
    let exersizeState
    if(state.questions.length <= state.currentQuestionIndex + 1) {
      exersizeState = 'scoreScrean'
    }
    dispatch({
      type: "SWITCH_QUESTION",
      exersizeState: exersizeState
    })
  },
  questionSwitched: () => ({
    type: "QUESTION_SWITCHED"
  })
}
